import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ProductQueryCategory } from "@models/product.model";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrl: "./footer.component.scss",
    standalone: false,
})
export class FooterComponent {
    currentYear = new Date().getFullYear();
    public isAdminRoute: boolean = false;
    public productQueryCategory = ProductQueryCategory

    constructor(private router: Router) {
        this.router.events.subscribe(() => {
            this.isAdminRoute = this.router.url.startsWith("/admin");
        });
    }
}
